import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class LogExecucaoIntegracaoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'log-execucao-integracao');
  }

  // Listar com filtros e paginação
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.estacao_id) {
      params = params.set('estacao_id', filtros.estacao_id);
    }
    if (filtros.integracao_id) {
      params = params.set('integracao_id', filtros.integracao_id);
    }
    if (filtros.status_code) {
      params = params.set('status_code', filtros.status_code);
    }
    if (filtros.data_inicio) {
      params = params.set('data_inicio', filtros.data_inicio);
    }
    if (filtros.data_fim) {
      params = params.set('data_fim', filtros.data_fim);
    }
    if (filtros.page) {
      params = params.set('page', filtros.page);
    }
    if (filtros.per_page) {
      params = params.set('per_page', filtros.per_page);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

}
